import axios from 'axios';

axios.defaults.baseURL = 'https://wabe-server-api.onrender.com';
axios.defaults.headers.post['Content-Type'] = 'application/json';

export default axios;
